import {DATA_TYPE_NAMES} from "../widget-constants";

export const GRID_DATA_TYPE_OPTIONS = [
    {value: DATA_TYPE_NAMES.AUDIT_POLICIES, label: "Audit Policies"},
    {value: DATA_TYPE_NAMES.DEVICES, label: "Devices"},
    {value: DATA_TYPE_NAMES.FILE_SERVERS, label: "File servers"},
    {value: DATA_TYPE_NAMES.FILES, label: "Files"},
    {value: DATA_TYPE_NAMES.OS_PLANS, label: "OS plans"},
    {value: DATA_TYPE_NAMES.SCHEDULES, label: "Schedules"},
];
